import { isHexColor } from '@/shared/lib/color';

import styles from './LabelStrip.module.css';

interface Props {
  labels: readonly { id: string; name: string; color: string }[];
}

/**
 * Board labels of a board card as a narrow colored strip along its left edge: one equal segment
 * per label in the board's own label order (like the task labels). The names stay available to
 * assistive technology and as a tooltip; the card text never sits on top of the colors.
 */
export function LabelStrip({ labels }: Props) {
  const shown = labels.filter((label) => isHexColor(label.color));
  if (shown.length === 0) return null;
  const names = shown.map((label) => label.name).join(', ');
  return (
    <span
      className={styles.strip}
      role="img"
      aria-label={names}
      title={names}
      data-testid="label-strip"
    >
      {shown.map((label) => (
        <span key={label.id} className={styles.segment} style={{ background: label.color }} />
      ))}
    </span>
  );
}
